import { useAppDispatch } from "../../../app/hooks";
import { HomeSectionBody, HomeSectionHeader } from "./homeSection";
import CommercialHistoryItem from "../../../chat/components/commercialHistoryItem";
import { clearConversation, clearCurrentCommercialPlan } from "../../../slices/chatSlice";
import { useCommercialHistoryConversations } from "../../../chat/hooks/useCommercialHistoryConversations";
import HomeTextAction from "./homeTextAction";
import { CommercialHistoryItemLayoutTypes, CommercialHistoryItemStatusTypes } from "../../workspace/components/types/commercialHistoryTypes";
import type { CommercialHistoryItemStatusType } from "../../../chat/hooks/useCommercialHistoryItem";

const LIMIT = 5;

type HomeRecentWorkProps = {
    onChange?: (conversationId: number) => void;
};

const HomeRecentWork = ({ onChange }: HomeRecentWorkProps) => {
    const dispatch = useAppDispatch();
    const { conversations, isLoading, isError } = useCommercialHistoryConversations();
    const visibleConversations = conversations.slice(0, LIMIT);

    const renderStatus = isLoading ? "loading" : isError ? "error" : "ready";
    const hasContent = visibleConversations.length > 0;

    const handleSelectConversation = (conversationId: number, status: CommercialHistoryItemStatusType): void => {
        dispatch(clearConversation());

        if (status === CommercialHistoryItemStatusTypes.OPEN_CONVERSATION) {
            dispatch(clearCurrentCommercialPlan());
        }

        onChange?.(conversationId);
    };

    return (
        <section aria-labelledby="home-opportunities-heading">
            <HomeSectionHeader
                title="Your work"
                titleId="home-opportunities-heading"
                action={<HomeTextAction>View Commercial History</HomeTextAction>}
                subtitle={renderStatus === "ready" && hasContent
                    ? "Potential actions Sovra has identified to improve commercial performance."
                    : undefined}
            />
            <HomeSectionBody
                status={renderStatus}
                hasContent={hasContent}
                loadingLabel="Loading conversations..."
                emptyLabel="No conversations yet."
                errorLabel="Unable to load conversations."
            >
                <div className="d-flex flex-column gap-2">
                    {visibleConversations.map(conversation => (
                        <CommercialHistoryItem
                            key={conversation.id}
                            conversation={conversation}
                            isSelected={false}
                            layout={CommercialHistoryItemLayoutTypes.INLINE}
                            onSelect={handleSelectConversation}
                        />
                    ))}
                </div>
            </HomeSectionBody>
        </section>
    );
};

export default HomeRecentWork;
